let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gGGz0")).then(() => parcelRequire('fiSL0'));